import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';

import { ADALandmarks, ADAARIARoles } from '../../../../models/ADA';

import './TitleArea.scss';

const mobileScreenThreshold = 767; // MUST BE IN SYNC WITH CSS

const TitleArea = React.forwardRef(({ theme, noThemeData, onSpin, darkMode, longestTitle, longestSubtitle }, theRef) => {
  const menuOpened = useSelector(state => state.data.menuOpened);
  const [spinInstructionsClass, setSpinInstructionsClass] = useState('');
  const refSpinInstructions = useRef(null);
  const refInstMaxHeight = useRef(0);

  useLayoutEffect(() => {
    const instHeight = refSpinInstructions.current.getBoundingClientRect().height;
    refInstMaxHeight.current = Math.max(refInstMaxHeight.current, instHeight);
    refSpinInstructions.current.style.height = refInstMaxHeight.current + 'px';

    if (theme && getViewportDimensions().width <= mobileScreenThreshold) {
      setSpinInstructionsClass('collapsed');
    } else {
      setSpinInstructionsClass('expanded');
    }
  }, [theme]);

  return (
    <div className={`ccw-intro-container ${darkMode ? 'dark-mode' : ''}`} ref={theRef}>
      <div className="cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className="cpvi-grid-col w6">
            <div className="ccw-main-text-holder">
              <div aria-hidden="true" className="ccw-main-text-sizer">
                <div className="ccw-main-title">{longestTitle}</div>
                <div className="ccw-main-subtitle cont-75">{longestSubtitle}</div>
              </div>
              <div className="ccw-title-and-subtitle">
                <h1 className="ccw-main-title" role={ADAARIARoles.Heading} >{theme ? theme.Title : noThemeData.Title}</h1>
                <div className="ccw-main-subtitle cont-75" >{theme ? theme.Subtitle : noThemeData.Subtitle}</div>
              </div>
            </div>
          </div>
          <div className="cpvi-grid-col w6">
            <div className="ccw-cta-text-holder">
              <div ref={refSpinInstructions} role={ADAARIARoles.Heading} className={`cont-75 ccw-cta-text-inner ${theme ? 'invisible' : 'showing'} ${spinInstructionsClass}`}>{noThemeData.CallToAction}</div>
              <div className="ccw-control-buttons">
                <button className={`ccw-button ${darkMode ? 'white' : 'black'}`} onClick={onSpin}>{theme ? noThemeData.SpinButton.SpinAgainLabel : noThemeData.SpinButton.SpinLabel}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default TitleArea;